import * as React from 'react';

import { IGlob } from '../ts/Glob';
import BooleanField from '../../../_common/platform/tsx/BooleanField';
import { IValuesCollection } from '../../../_common/platform/ts/appTheme';

declare var Color: any;

const HIDE_INTRO_MESSAGE = 'hide-intro-message';

export default function IntroView(props: { navigationBarHeight: number; theme: IValuesCollection; glob: IGlob }) {
    const hideIntroView = props.glob.AppStore.getFromLocalStorage(HIDE_INTRO_MESSAGE);

    if (hideIntroView === '1') {
        return null;
    }

    const { theme } = props;
    const authData = props.glob.AppStore.getAuthenticationData();

    const handleOnHideIntroMessage = (value: boolean) => {
        if (value) {
            props.glob.AppStore.saveToLocalStorage(HIDE_INTRO_MESSAGE, '1');
        } else {
            props.glob.AppStore.removeFromLocalStorage(HIDE_INTRO_MESSAGE);
        }
    };

    const style: React.CSSProperties = {};
    const backgroundColor = theme['surface-bg'];

    if (backgroundColor != null) {
        style.backgroundColor = Color(backgroundColor).dark()
            ? Color(backgroundColor).lighten(10).hexString()
            : Color(backgroundColor).darken(10).hexString();
    }

    if (props.navigationBarHeight > 0) {
        style.top = props.navigationBarHeight;
    }

    return (
        <div className="workspace-view-introduction" style={style}>
            <p className="welcome-message">
                <span>{'Welcome '}</span>
                <span className="user-name">{authData.displayName + '!'}</span>
            </p>
            <p>
                <span>{'Please, use the menu to choose what should be displayed'}</span>
            </p>
            <BooleanField title={'Do not show it in the future'} onChange={handleOnHideIntroMessage} />
        </div>
    );
}
